<template>
    <div class="n2-container" style="position: relative;">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.orders.back') }}
                    </span>
                </div>
            </a>
        </div>
        <h5 class="n2-text-center">{{ $t('pages.admin.orders.title') }}</h5>
        <div>
            <div class="n2-margin-top" style="background-color: #ffffff;">
                <div style="border-bottom:1px solid #cccccc;">
                    <div class="n2-toolbar">
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="clearFilter()">
                                <i class="fa fa-trash n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.orders.empty_filter') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="reload()">
                                <i class="fa fa-refresh n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.orders.reload') }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="n2-row">
                <div class="col-md-2">
                    <form-input type="text" v-model="query.email" v-bind:autocomplete="'one-time-code'"
                        v-bind:label="$t('pages.admin.orders.email')"></form-input>
                </div>
                <div class="col-md-2">
                    <form-input type="text" v-model="query.customer_name" v-bind:autocomplete="'one-time-code'"
                        v-bind:label="$t('pages.admin.orders.customer_name')"></form-input>
                </div>
                <div class="col-md-2">
                    <form-input type="text" v-model="query.booking_number" v-bind:autocomplete="'one-time-code'"
                        v-bind:label="$t('pages.admin.orders.booking_number')"></form-input>
                </div>
                <div class="col-md-2">
                    <form-input type="text" v-model="query.phone_number" v-bind:autocomplete="'one-time-code'"
                        v-bind:label="$t('pages.admin.orders.phone_number')"></form-input>
                </div>
                <div class="col-md-2">
                    <form-input type="select" v-model="query.status" v-bind:label="$t('pages.admin.orders.status')">
                        <template v-slot:options>
                            <option value=""></option>
                            <option value="open">Open</option>
                            <option value="closed">Closed</option>
                            <option value="cancelled">Cancelled</option>
                        </template>
                    </form-input>
                </div>
                <div class="col-md-2">
                    <form-input type="select" v-model="query.template" v-bind:label="$t('pages.admin.orders.template')">
                        <template v-slot:options>
                            <option value=""></option>
                            <option v-for="t in templates" v-bind:key="t" v-bind:value="t">{{ t }}</option>
                        </template>
                    </form-input>
                </div>
            </div>




            <div class="n2-row">
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.created_at_min') }}</label>
                        <app-calendar v-model="query.created_at_min" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.created_at_max') }}</label>
                        <app-calendar v-model="query.created_at_max" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.depart_at_min') }}</label>
                        <app-calendar v-model="query.depart_at_min" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.depart_at_max') }}</label>
                        <app-calendar v-model="query.depart_at_max" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.cancelled_at_min') }}</label>
                        <app-calendar v-model="query.cancelled_at_min" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="n2-form-group">
                        <label class="n2-form-label">{{ $t('pages.admin.orders.cancelled_at_max') }}</label>
                        <app-calendar v-model="query.cancelled_at_max" v-bind:locale="locale"
                            v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css">
                        </app-calendar>
                    </div>
                </div>
            </div>
        </div>
        <div style="margin:10px 0 20px;">
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="query.page_number"
                v-bind:page_size="query.page_size" v-bind:total_size="total_size"></pager>
        </div>
        <div style="position:relative;">
            <div v-if="orders.length > 0" class="n2-grid-0" v-bind:style="{ 'grid-template-columns': grid_columns }">
                <template v-for="col in columns">
                    <div v-if="col == 'select'" class="n2-grid-cell n2-grid-header" v-bind:key="col">
                        <label>
                            {{ $t('pages.admin.orders.select') }}
                        </label>
                    </div>
                    <div v-if="col == 'booking_number'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.booking_number') }}
                        </label>
                    </div>
                    <div v-if="col == 'email'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.email') }}
                        </label>
                    </div>
                    <div v-if="col == 'phone_number'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.phone_number') }}
                        </label>
                    </div>
                    <div v-if="col == 'customer_name'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.customer_name') }}
                        </label>
                    </div>
                    <!-- <div v-if="col == 'locale'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.locale') }}
                        </label>
                    </div> -->
                    <div v-if="col == 'ticket_total'" class="n2-grid-cell n2-grid-header" style="text-align: right;">
                        <label>
                            {{ $t('pages.admin.orders.ticket_total') }}
                        </label>
                    </div>
                    <div v-if="col == 'total'" class="n2-grid-cell n2-grid-header" style="text-align: right;">
                        <label>
                            {{ $t('pages.admin.orders.total') }}
                        </label>
                    </div>
                    <div v-if="col == 'template'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.template') }}
                        </label>
                    </div>
                    <div v-if="col == 'created_at'" class="n2-grid-cell n2-grid-header">
                        <a v-on:click="sort('created_at')">
                            {{ $t('pages.admin.orders.created_at') }}
                            <template v-if="sortings.created_at === 1">
                                &#9650;
                            </template>
                            <template v-if="sortings.created_at === 2">
                                &#9660;
                            </template>
                        </a>
                    </div>
                    <div v-if="col == 'status'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.status') }}
                        </label>
                    </div>
                    <div v-if="col == 'cancelled_at'" class="n2-grid-cell n2-grid-header">
                        <a v-on:click="sort('cancelled_at')">
                            {{ $t('pages.admin.orders.cancelled_at') }}
                            <template v-if="sortings.cancelled_at === 1">
                                &#9650;
                            </template>
                            <template v-if="sortings.cancelled_at === 2">
                                &#9660;
                            </template>
                        </a>
                    </div>
                    <!-- <div v-if="col == 'support_status'" class="n2-grid-cell n2-grid-header">
                        <label>
                            {{ $t('pages.admin.orders.support_status') }}
                        </label>
                    </div> -->
                    <div v-if="col == 'trips'" class="n2-grid-cell n2-grid-header">
                        <label> {{ $t('pages.admin.orders.trips') }}</label>
                    </div>
                </template>

                <template v-for="(entity, index) in orders">
                    <template v-for="col in columns" v-bind:key="entity.id">
                        <div v-if="col == 'select'" class="n2-grid-cell" v-bind:key="col">
                            <label class="n2-checkbox-lable">
                                <input type="checkbox" class="n2-checkbox-input" v-model="entity.selected" />
                                <!--v-bind:disabled="entity.capacity_processing_status == 2 || entity.capacity_processing_status == 3 || entity.capacity_processing_status == 4"-->
                                <span class="n2-checkbox-text">{{ index + 1 }}</span>
                            </label>
                        </div>
                        <div v-if="col == 'booking_number'" class="n2-grid-cell">
                            <a v-bind:href="`/${app_locale}/admin/orders/${entity.id}`">
                                {{ entity.booking_number }}
                            </a>
                        </div>
                        <div v-if="col == 'email'" class="n2-grid-cell">
                            <label>
                                {{ entity.contact.email }}
                            </label>
                        </div>
                        <div v-if="col == 'phone_number'" class="n2-grid-cell">
                            <label>
                                {{ entity.contact.phone_number }}
                            </label>
                        </div>
                        <div v-if="col == 'customer_name'" class="n2-grid-cell">
                            <label>
                                {{ entity.contact.given_name }}
                                {{ entity.contact.middle_name }}
                                {{ entity.contact.family_name }}
                            </label>
                        </div>
                        <!-- <div v-if="col == 'locale'" class="n2-grid-cell">
                            <label>
                                {{ entity.locale }}
                            </label>
                        </div> -->
                        <div v-if="col == 'ticket_total'" class="n2-grid-cell" style="text-align: right;">
                            <label>
                                {{ formatNumber(entity.ticket_total) }} NOK
                            </label>
                        </div>
                        <div v-if="col == 'total'" class="n2-grid-cell" style="text-align: right;">
                            <label>
                                {{ formatNumber(entity.total) }} NOK
                            </label>
                        </div>
                        <div v-if="col == 'template'" class="n2-grid-cell">
                            <label>
                                {{ entity.template }}
                            </label>
                        </div>
                        <div v-if="col == 'created_at'" class="n2-grid-cell">
                            <label>
                                {{ getDateTimeString(entity.created_at) }}
                            </label>
                        </div>
                        <div v-if="col == 'status'" class="n2-grid-cell">
                            <label>
                                {{ entity.status }}
                            </label>
                        </div>
                        <div v-if="col == 'cancelled_at'" class="n2-grid-cell">
                            <label v-if="entity.cancelled_at">
                                {{ getDateTimeString(entity.cancelled_at) }}
                            </label>
                        </div>
                        <div v-if="col == 'trips'" class="n2-grid-cell">
                            <div v-for="(leg, legIndex) in entity.legs" v-bind:key="leg.id" style="display: table;"
                                v-bind:class="{ 'n2-text-cancelled': (entity.status == 'cancelled' || leg.status == 'cancelled') }">
                                <div v-if="legIndex > 0" style="border-top: 1px dashed #000000; display: table-row;">
                                </div>
                                <template v-for="step in leg.steps">
                                    <div v-if="step.travel_mode == 'transit'" style="display: table-row;">
                                        <div style="display: table-cell; padding: 5px;">
                                            {{ getShortDateTimeString(step.transit.depart_at) }}
                                        </div>
                                        <div style="display: table-cell; padding: 5px;">
                                            {{ step.transit.departure_stop.name }}
                                        </div>
                                        <div style="display: table-cell; padding: 5px;">
                                            {{ getShortDateTimeString(step.transit.arrive_at) }}
                                        </div>
                                        <div style="display: table-cell; padding: 5px;">
                                            {{ step.transit.arrival_stop.name }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <!-- <div v-if="col == 'support_status'" class="n2-grid-cell">
                            <label>
                                {{ entity.support_status }}
                            </label>
                        </div> -->
                        <!-- <div v-if="col == 'pdf'" class="n2-grid-cell">
                            <a href="#" v-on:click.prevent="download(entity)">
                                {{ $t('pages.admin.orders.pdf') }}
                            </a>
                        </div> -->
                    </template>
                </template>
            </div>
            <div v-else class="title-default">
                {{ $t('pages.admin.orders.no_record') }}
            </div>
        </div>
        <div style="margin:20px 0;">
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="query.page_number"
                v-bind:page_size="query.page_size" v-bind:total_size="total_size"></pager>
        </div>
        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from '../shared';
import { OrderService, ConfigurationService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import Pager from '../components/shared/pager.vue';
import FormInput from '../components/shared/form-input.vue';
import AppCalendar from '../components/shared/calendar.vue'
import helper from '../helpers/localization-helper'


export default {
    components: {
        AppLoader, Pager, FormInput, AppCalendar
    },
    data: function () {
        return {
            query: {
                sort_by: '',
                sort_direction: '',
                template: '',
                status: '',
                created_at: '',
                phone_number: '',
                customer_name: '',
                booking_number: '',
                email: '',
                //support_status: '',
                page_size: 10,
                page_number: 1,
                created_at_min: '',
                created_at_max: '',
                depart_at_min: '',
                depart_at_max: '',
                cancelled_at_min: '',
                cancelled_at_max: ''
            },
            sortings: {
                created_at: 0,
                cancelled_at: 0,
            },
            templates: [],
            orders: [],
            loading: false,
            total_size: 0,
            columns: ['booking_number', 'email', 'phone_number', 'customer_name', 'ticket_total', 'total', 'template', 'created_at', 'status', 'cancelled_at', 'trips'],
        }
    },
    watch: {
        'query.sort_by': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.sort_direction': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.template': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.status': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        // 'query.support_status': function () {
        //     this.query.page_number = 1;
        //     this.debouncedSearch();
        // },
        'query.order_by': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.order_by_mode': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.email': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.booking_number': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.phone_number': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.customer_name': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.created_at_min': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.created_at_max': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.depart_at_min': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.depart_at_max': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.cancelled_at_min': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        },
        'query.cancelled_at_max': function () {
            this.query.page_number = 1;
            this.debouncedSearch();
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
        ]),
        ...mapGetters('globalization', [
            'locale',
        ]),
        ...mapGetters('identity', [
            'user',
        ]),
        grid_columns_length: function () {
            let len = this.columns.length + 1;
            return len;
        },
        grid_columns: function () {
            return new Array(this.grid_columns_length).join('auto ');
        },
    },

    created: function () {
        this.configurationService = new ConfigurationService();
        this.orderService = new OrderService()
        this.debouncedSearch = debounce(this.nav, 1000);
    },
    mounted: async function () {
        this.templates = await this.configurationService.getTemplates();

        setTimeout(async () => {
            Object.assign(this.query, this.$route.query);
            await this.search();
        }, 1);
    },
    beforeRouteUpdate(to, from, next) {
        Object.assign(this.query, to.query);
        this.search();
        next();
    },
    methods: {
        getDateTimeString: function (source) {
            return helper.getDateTimeString(source);
        },
        getShortDateTimeString: function (source) {
            return helper.getShortDateTimeString(source);
        },
        formatNumber: function (source) {
            return helper.formatNumber(source);
        },
        clearFilter: function () {
            this.query = {
                sort_by: '',
                sort_direction: '',
                template: '',
                status: '',
                created_at: '',
                phone_number: '',
                customer_name: '',
                booking_number: '',
                email: '',
                //support_status: '',
                page_size: 10,
                page_number: 1,
                created_at_min: '',
                created_at_max: '',
                depart_at_min: '',
                depart_at_max: '',
                cancelled_at_min: '',
                cancelled_at_max: ''
            };
        },
        reload: function () {
            this.search();
        },
        getTrips: function (order) {
            try {
                let transits = [];
                order.legs.forEach((l, index) => {
                    let firstTransit = l.steps.filter(s => s.travel_mode == 'transit')[0].transit;
                    let lastTransit = l.steps.filter(s => s.travel_mode == 'transit')[l.steps.filter(s => s.travel_mode == 'transit').length - 1].transit;
                    if (index == 0) {
                        transits.push(this.getDateTimeString(firstTransit.local_depart_at) + ' ' + firstTransit.departure_stop.name);
                    }
                    transits.push(this.getDateTimeString(lastTransit.local_arrive_at) + ' ' + lastTransit.arrival_stop.name);
                });
                return transits.join(' -> ')
            }
            catch (e) {
                console.log(e)
            }
        },
        navBack: function () {
            return this.$router.push({ path: `/${this.app_locale}/admin/` })
        },
        sort: function (field) {
            // this.sortings[field] = (this.sortings[field] + 1) % 3;
            // this.query.sort_by = this.sortings[field] == 0 ? '' : field;
            // this.query.sort_direction = this.sortings[field] == 0 ? '' : this.sortings[field] == 1 ? 'asc' : 'desc';
            // Object.keys(this.sortings).filter(k => { return k !== field; }).forEach(k => this.sortings[k] = 0);
        },
        search: async function () {
            this.loading = true;
            try {
                let searchQuery = {};
                Object.assign(searchQuery, this.query);
                searchQuery.template = this.query.template;
                if (this.query.created_at_max) {
                    searchQuery.created_at_max = helper.addDays(this.query.created_at_max, 1).substring(0, 10);
                }
                if (this.query.depart_at_max) {
                    searchQuery.depart_at_max = helper.addDays(this.query.depart_at_max, 1).substring(0, 10);
                }
                if (this.query.cancelled_at_max) {
                    searchQuery.cancelled_at_max = helper.addDays(this.query.cancelled_at_max, 1).substring(0, 10);
                }
                let response = await this.orderService.search(searchQuery);
                this.orders = response.data;
                this.total_size = response.total_size;
                this.query.page_number = response.page_number;
            }
            catch {
                this.orders = []
            }
            finally {
                this.loading = false
            }

        },
        nav: function () {
            this.$router.push({
                path: '', query: this.query
            }).catch(() => { });
        },
        navToPage: function (page_number) {
            this.query.page_number = page_number
            this.nav()
        }
    }
}
</script>
